import { stepperAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    stepperAnatomy.keys
);

const baseStyle = definePartsStyle({
    indicator: {
        '&[data-status="active"]': {
            borderColor: 'primary.400'
        },
        '&[data-status="complete"]': {
            background: 'primary.400',
            borderColor: 'primary.400'
        }
    },
    separator: {
        '&[data-status="complete"]': {
            background: 'primary.400'
        }
    }
});

export const stepperTheme = defineMultiStyleConfig({ baseStyle });
